import axios from "axios";
import store from "../redux/store";
import { getClientID, getURL } from "../redux/selectors";

const print = async ({ reqID, format }) => {
  const state = store.getState();
  const url = getURL(state);
  const clientID = getClientID(state);

  return await axios
    .post(`${process.env.REACT_APP_BACKEND_DOMAIN}/d1services`, {
      url,
      data: {
        service: "print",
        clientID,
        reqID,
        format,
        appID: process.env.REACT_APP_SOFTONE_APPID,
      },
    })
    .then((res) => res.data)
    .catch((er) => ({ success: false, error: er.message }));
};

export default print;
